export function getIdByLegalFormName(value) {
	return Object.keys(dict).find(key => dict[key] === value);
}

export function getLegalFormNameById(id) {
	return dict[id];
}

export function getDictionary () {
	return dict;
}

let dict = {
	0: "Fundacja",
	1: "Stowarzyszenie",
	2: "Stowarzyszenie samorządowe",
	3: "Stowarzyszenie kultury fizycznej",
	4: "Związek stowarzyszeń",
	5: "Stowarzyszenie zwykłe",
	6: "Organizacja kościelna",
	7: "Spółdzielnia socjalna",
	8: "Spółka non-profit",
	9: "Klub sportowy",
	10: "Izba gospodarcza",
	11: "Izba rolnicza",
	12: "Inny podmiot",

	13: "Publiczna szkoła wyższa",
	14: "Niepubliczna szkoła wyższa",
	15: "Instytut badawczy",
	16: "Polska Akademia Nauk",
	17: "Krajowa Szkoła Administracji Publicznej",
	18: "Inna instytucja",

	19: "Ministerstwo",
	20: "Urząd centralny",
	21: "Urząd wojewódzki",
	22: "Inny organ",

	23: "Gmina",
	24: "Powiat",
	25: "Województwo",
	26: "Inna jednostka",
};
